<template>
    <FormGroupNew :label="__('sale.delivery_note_info.company_register_number')"
                  :error="value.errors.reg_id"
                  :warning="requiresAdditionalInfo && !localForm.reg_id"
                  required
    >
        <input type="text"
               class="form-control"
               placeholder="12345678"
               v-model="localForm.reg_id"
               required
        >
    </FormGroupNew>
</template>

<script>
import FormGroupNew from "@components/Form/FormGroupNew.vue";

export default {
    components: {FormGroupNew},

    props: {
        value: Object,
        requiresAdditionalInfo: Boolean
    },

    data() {
        return {
            localForm: this.value
        };
    },

    watch: {
        localForm: {
            deep: true,
            handler(newValue, oldValue) {
                this.$emit('input', newValue)
            }
        }
    }
}
</script>
